import * as stylex from "@stylexjs/stylex";
import { headerStyles as styles } from "./one-pager-header.styles";

export function OnePagerHeaderLoading({ accent }: { readonly accent: string }) {
  return (
    <header {...stylex.props(styles.hero, styles.accent(accent))}>
      <div {...stylex.props(styles.coverBlank)} />
      <div {...stylex.props(styles.heroBody)} />
    </header>
  );
}
